import TYPES from './types';

//define initialState
const [_, obfuscatedLenderDatabaseId, obfuscatedLoanRecordId, attachDocs] =
  globalThis.location.pathname.split('/');

/* URL obfuscatedLoanIdentifier */
const urlInitialState = {
  obfuscatedLoanIdentifier: {
    obfuscatedLenderDatabaseId: Number.parseInt(obfuscatedLenderDatabaseId),
    obfuscatedLoanRecordId: Number.parseInt(obfuscatedLoanRecordId),
  },
  attachDocs: attachDocs !== '' && attachDocs === 'true',
};

export const url = (state = urlInitialState, { type, payload }) => {
  switch (type) {
    case TYPES.URL_SET_LOAN_PARAMS:
      return {
        ...state,
        obfuscatedLoanIdentifier: payload,
      };
    case TYPES.URL_SET_ATTACH_PARAMS:
      return {
        ...state,
        attachDocs: payload,
      };
    case TYPES.URL_SET_ALL_PARAM:
      return {
        obfuscatedLoanIdentifier: payload.obfuscatedLoanIdentifier,
        attachDocs: payload.attachDocs,
      };
    default:
      return state;
  }
};

const upsertOrDeleteInitialState = {
  loanSummaryUpsertOrDelete: false,
};

export const loanSummaryUpsertOrDelete = (
  state = upsertOrDeleteInitialState,
  { type, payload },
) => {
  switch (type) {
    case TYPES.SET_LOAN_SUMMARY_UPSERT_OR_DELETE:
      return {
        ...state,
        loanSummaryUpsertOrDelete: payload,
      };
    default:
      return state;
  }
};
